import ajax from '../http/ajax'

export const getCarLine = params => {
    return ajax.get('getCarLine', params)
}
